'use client';
import useSWR from 'swr';
import { API_URLS, SWR_REQUEST_DEFAULTS } from '@/lib/api/config';
import { TypePlayGeniusInvoice } from '@/lib/api/productCatalog/types';

export default function useInvoices(invoiceUuids: string[]) {
  const uri = `${API_URLS.PRODUCT_CATALOG_PROXY}/checkout_orchestration/invoices?invoice_uuids=${invoiceUuids.join(',')}`;

  const {
    data: invoicesData,
    isLoading: invoicesLoading,
    error: invoicesError,
    mutate: mutateInvoices,
  } = useSWR<TypePlayGeniusInvoice[], Error>(uri, SWR_REQUEST_DEFAULTS);

  return {
    invoicesData,
    invoicesLoading,
    invoicesError,
    mutateInvoices,
  };
}
